@if(tooltip) {
  <ul>
    @for(item of list; track item) {
      <li (click)="onClick(item)">
        <span matTooltip="{{item[tooltip!]}}" matTooltipPosition="right">{{item[label]}}</span>
      </li>
    }
  </ul>
} @else {
  <ul>
    <li *ngFor="let item of list" (click)="onClick(item)">
      <span>{{label === "employee" ? item.lastname + " " + item.firstname : item[label]}}</span>
    </li>
  </ul>
}
